// src/pages/PagesUtilisateurs/DashboardUsers/ui/DashboardEmptyState.jsx

import React from "react";

export default function DashboardEmptyState({
  icon: Icon,
  title,
  description,
  action,
}) {
  return (
    <div className="rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50/60 px-5 py-10 text-center dark:border-slate-700 dark:bg-slate-950/40">
      {Icon ? (
        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-lg text-slate-400 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-800">
          <Icon />
        </span>
      ) : null}

      <h4 className="mt-4 font-bold text-slate-900 dark:text-white">
        {title}
      </h4>

      {description ? (
        <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-500 dark:text-slate-400">
          {description}
        </p>
      ) : null}

      {action ? (
        <div className="mt-5">{action}</div>
      ) : null}
    </div>
  );
}